'use client';

import { useEffect, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

function ScrollToTopInner() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const timer = setTimeout(() => {
                const el = document.getElementById(hash.replace('#', ''));
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
            return () => clearTimeout(timer);
        }
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname, searchParams]);

    return null;
}

export default function ScrollToTop() {
    return (
        <Suspense fallback={null}>
            <ScrollToTopInner />
        </Suspense>
    );
}
